// src/pages/OurTeam.tsx
import React from 'react';

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";


import GetInTouch from '../components/GetInTouch';

const OurTeam: React.FC = () => {

const seo = seoConfig.ourTeam; // ✅ Load meta for this page


  return (


<>



      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />


  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-team bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Our Team</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}





{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  





</>


  );
};

export default OurTeam;
